// extracted by mini-css-extract-plugin
module.exports = {"button":"SignOut_button__S_FI8"};